import Api from "../axios";

export default async function apiApproveEarlyLeaving(id) {
  return await Api.post(`/auto_approve`, {
    application_id: id,
  });
}
